import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/MobileHome.css';

const Home = () => {
  useEffect(() => {
    document.title = 'TrafikBevakning - Hitta lediga tider automatiskt';
    document.body.className = 'body-2';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <>
      <section className="gpt-hero-section">
        <div className="gpt-hero-left">
          <h1 className="gpt-hero-heading">
            <span className="text-span-3">Missa aldrig en tid igen.</span>
          </h1>
          <p className="paragraph-2">
            Det utförs över 350000+ körprov och 630000+ teoriprov varje år i Sverige - att få en tid
            är inte alltid lätt och i stället för att behöva åka över halva Sverige till en mindre
            by kan du hitta dem tiderna du vill ha direkt när de blir tillgängliga. <br />‍<br />
            Ta en kaffe eller gå på din lektion, vi håller koll.
          </p>
          <Link to="/plans" className="gpt-hero-button w-inline-block">
            <div className="text-block-5">Börja Bevaka</div>
          </Link>
        </div>
        <div className="gpt-hero-right">
          <img
            sizes="(max-width: 1287px) 100vw, 1287px"
            srcSet="/images/new500_nobg.png 500w, /images/new800_nobg.png 800w, /images/new1080_nobg.png 1080w, /images/new_nobg.png 1287w"
            alt="En dator och en bild med en skärmbild som visar produkten."
            src="/images/new_nobg.png"
            loading="lazy"
            className="image-3"
          />
        </div>
      </section>

      <section className="gpt-social-proof-section">
        <div className="gpt-social-proof-box">
          <div className="gpt-social-proof-text">1000+ aktiva användare</div>
        </div>
        <div className="gpt-social-proof-box">
          <div className="gpt-social-proof-text">3000+ nya körkortstagare</div>
        </div>
        <div className="gpt-social-proof-box">
          <div className="gpt-social-proof-text">15000+ meddelanden skickade</div>
        </div>
      </section>
    </>
  );
};

export default Home;
